import React, { memo } from 'react'

// Skeleton loading
import Skeleton from 'react-loading-skeleton';

function Logo__loadingSkeleton() {
    return (
        <React.Fragment>
            <div className="d-flex overflow-hidden">
                <div className="me-3">
                    <Skeleton count={1} height={150} width={150} />
                </div>
                <div className="ms-auto">
                    <div className="mb-3">
                        <Skeleton count={1} height={25} width={150} />
                    </div>
                    <div className="mb-3">
                        <Skeleton count={1} height={20} width={100} />
                    </div>
                    <div className="mb-3">
                        <Skeleton count={1} height={20} width={200} />
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default memo(Logo__loadingSkeleton)